const DATE_FILTER_MAX_DAYS = {
  today: 0,
  week: 7,
  month: 30,
};

export function filterContactActivities(
  activities,
  activityFilter = "all",
  dateFilter = "all"
) {
  const maximumDays = DATE_FILTER_MAX_DAYS[dateFilter];

  return activities.filter((activity) => {
    const matchesActivity =
      activityFilter === "all" || activity.type === activityFilter;
    const matchesDate =
      maximumDays === undefined || activity.daysAgo <= maximumDays;

    return matchesActivity && matchesDate;
  });
}

export function groupContactActivities(activities) {
  return [
    {
      key: "today",
      label: "Today",
      activities: activities.filter((activity) => activity.daysAgo === 0),
    },
    {
      key: "previous",
      label: "Previous activity",
      activities: activities.filter((activity) => activity.daysAgo > 0),
    },
  ].filter((section) => section.activities.length > 0);
}
